import { forwardRef, type Ref, type SVGProps } from "react";
const IconHeatFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M14 5.665c-.736 0-1.333.597-1.333 1.333v12.95a3.332 3.332 0 1 0 4.619 3.617 3.33 3.33 0 0 0-1.952-3.617V6.998c0-.736-.597-1.333-1.334-1.333" />
    <path
      fillRule="evenodd"
      d="M19 18.105V6.998A5 5 0 0 0 14 2a5 5 0 0 0-5 4.998v11.107a6.996 6.996 0 0 0 .067 9.862 7 7 0 0 0 9.866 0A6.996 6.996 0 0 0 19 18.105m-5 9.887a5 5 0 0 1-3.57-8.498l.57-.58V6.999a3 3 0 0 1 6 0v11.917l.57.58A4.997 4.997 0 0 1 14 27.991"
      clipRule="evenodd"
    />
    <path d="M19.667 6.998a1 1 0 0 1 1-1H24a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1m1 4.332a1 1 0 1 0 0 2H24a1 1 0 1 0 0-2zm-1 6.332a1 1 0 0 1 1-1H24a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1m1-8.997a1 1 0 1 0 0 1.999h2a1 1 0 1 0 0-2zm-1 6.331a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1" />
  </svg>
);
const ForwardRef = forwardRef(IconHeatFilledSVG);
ForwardRef.displayName = "IconHeatFilled";
export { ForwardRef as IconHeatFilled };
